import React from 'react';

import About from './pages/About';
import Team from './pages/Team';
import Publications from './pages/Publications';
import Prototypes from "./pages/Prototypes";
import Positions from "./pages/Positions";
import ReactMarkdown from 'react-markdown';

const configuration = {
    title: "CLAY",
    subtitle:
        <div>
            <ReactMarkdown source={"An Environment for Live Construction of Trustworthy Software"}/>
            <ReactMarkdown source={"PTDC/EEI­CTP/4293/2014 ([NOVA LINCS](http://nova-lincs.di.fct.unl.pt/project/234))"}/>
        </div>
};

const pages = [
    {
        key:"about",
        path:"/",
        label:"About",
        component:() => <About page={this}/>
    },
    {
        key:"team",
        path:"/team",
        label:"Team",
        component:() => <Team page={this}/>
    },
    {
        key:"publications",
        path:"/publications",
        label:"Publications",
        component:()=> <Publications page={this}/>
    },
    {
        key:"prototypes",
        path:"/prototypes",
        label:"Prototypes",
        component:() => <Prototypes page={this}/>
    },
    {
        key:"positions",
        path:"/positions",
        label:"Positions",
        component:() => <Positions page={this}/>
    },

];

export { configuration, pages }